
import './style.scss'
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
// import { userStateData } from '../../data/userStateData';
import { setDataLoadRequestFinished } from '../../redux/reducers/userSlice';
import { setSubPage } from '../../redux/reducers/dashboardSlice';
import { DashboardSubPages } from '../../types/types';
import { adminConnector } from '../../server/connector/adminConnector';
import AdminSideMenu from '../../sections/adminSideMenu/AdminSideMenu';
import AdminHeader from '../../sections/adminHeader/AdminHeader';
import { useCookies } from 'react-cookie';
import { adminStateData } from '../../data/adminStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';
import AdminChatsContentArea from '../../sections/adminChatsContentArea/AdminChatsContentArea';

function AdminChats() {
	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)
	const dispatch = useAppDispatch()
	const [cookies] = useCookies()

	useEffect(() => {
		dispatch(setSubPage(DashboardSubPages.ADMIN_CHATS))
		// check if log in has been checked and confirmed in App.tsx
		if (cookies?.adminLogin) {
			adminStateData.loggedIn = cookies?.adminLogin
			loadChatData()
		} else {
			window.location.replace(PAGE_URLS.ADMIN_LOGIN)
		}
	}, [loginChecked])

	const loadChatData = () => {
		if (adminConnector.requestInProgress) {
			console.log('[Dashboard] - loadChatData() called while requestInProgress')
		} else {
			adminConnector.performGetAdminChatsRequest().then((requestStatus) => {
				if (!requestStatus) {
					console.log('WARNING - [Admin] - performGetAdminChatsRequest() failed')
				}
				dispatch(setDataLoadRequestFinished(true))
			})
		}
	}

	return (
		<div className='dashboard-wrap'>
			{loginChecked &&
				<>
					<AdminSideMenu />
					<div
						className='dashboard-content-wrap'
					>
						<AdminHeader title='Admin - Chats' />
						<AdminChatsContentArea />
					</div>
				</>
			}
		</div>
	)
}

export default AdminChats
